import React from "react";
import { Navigate } from "react-router-dom";

import ListComponent from "../../../../../components/checkpoint/components/list/page";
import AddComponent from "../../../../../components/extra-checkpoint-1/components/add/page";

export const extrasCheckpointOneRoute = [
  {
    path: "list",
    element: <ListComponent />,
  },
  {
    path: "add",
    element: <AddComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/extras/checkpoint-one/add" />,
  },
  {
    path: "edit/:id",
    element: <AddComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/extras/checkpoint-one/add" />,
  },
];
